import React from "react";
import Icon from "../../../components/Icon";
import SearchCriteria from "./SearchCriteria";
import SearchInput from "./SearchInput";
import SearchPopover from "./SearchPopover";

import styles from "./Search.module.scss";

const Search = ({
  criteria,
  onChange,
  onSearch,
  options = [],
  searchLabel,
  searchRelatedIdentities = false
}) => {
  const [hasFocus, setFocus] = React.useState(false);
  const [isPopoverVisible, setPopoverVisible] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const criteriaRef = React.createRef();
  const inputRef = React.createRef();
  const popoverRef = React.createRef();

  React.useEffect(() => {
    if (hasFocus) {
      inputRef.current.focus();
      if (searchText.trim() !== "") {
        setPopoverVisible(true);
      }
    }
  }, [hasFocus, inputRef, searchText]);

  return (
    <div className={styles.base}>
      {searchLabel && <label htmlFor="search">{searchLabel}</label>}
      <span
        className={`${styles.input} ${hasFocus ? styles.focus : ""}`}
        onBlur={({ currentTarget, relatedTarget }) => {
          if (!currentTarget.contains(relatedTarget)) {
            setPopoverVisible(false);
          }
        }}
      >
        {criteria && criteria.length > 0 && (
          <SearchCriteria
            criteria={criteria}
            onRemove={key => {
              onChange(criteria.filter(prev => prev.key !== key));
              inputRef.current.focus();
            }}
            ref={criteriaRef}
          />
        )}
        <SearchInput
          id="search"
          hasCriteria={criteria && criteria.length > 0}
          onChange={value => {
            setSearchText(value);
            setPopoverVisible(value.trim() !== "");
          }}
          onBlur={() => setFocus(false)}
          onFocus={() => setFocus(true)}
          onKeyDown={event => {
            const { key } = event;
            if (key === "Backspace") {
              if (criteriaRef.current === null) return;
              if (searchText.trim() !== "") return;
              criteriaRef.current
                .querySelector("[data-criteria]:last-child")
                .focus();
            }
            if (key === "ArrowDown" || key === "ArrowUp") {
              if (popoverRef.current === null) return;
              if (searchText.trim() === "") return;
              event.preventDefault();
              popoverRef.current
                .querySelector("[data-option]:first-child")
                .focus();
            }
          }}
          ref={inputRef}
          searchText={searchText}
        />
        <SearchPopover
          criteria={criteria}
          onAdd={({ key, label }) => {
            const copyCriteria = criteria ? [...criteria] : [];
            onChange([
              ...copyCriteria,
              { key, label, value: searchText.trim() }
            ]);
            setSearchText("");
            setPopoverVisible(false);
            setFocus(true);
          }}
          options={options}
          ref={popoverRef}
          searchText={searchText}
          visible={isPopoverVisible}
        />
      </span>
      <button
        onClick={searchRelatedIdentities =>
          onSearch(searchRelatedIdentities, false)
        }
      >
        <Icon size="1.5rem" type="search" />
      </button>
    </div>
  );
};

export default Search;
